import { render, staticRenderFns } from "./BrandButtons.vue?vue&type=template&id=b8b4cf66&scoped=true&"
import script from "./BrandButtons.vue?vue&type=script&lang=js&"
export * from "./BrandButtons.vue?vue&type=script&lang=js&"
import style0 from "./BrandButtons.vue?vue&type=style&index=0&id=b8b4cf66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b4cf66",
  null
  
)

export default component.exports